mod.modules.define("CustomizeTableColumns", "BaseModule", function(fn) {

	var cache = {
		$selectedTable: null,
		$hiddenTable: null
	};

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.tableId = params.tableId || "";
		this.maxColumns = params.maxColumns || 5;

		// Cache
		cache.$selectedTable = this.el.find(".customizecolumns-table-selected table");
		cache.$hiddenTable = this.el.find(".customizecolumns-table-hidden table");

		this._init_dragging(cache.$selectedTable);
	};

	fn.prototype._init_dragging = function($table) {
		var self = this;

		$table.tableDnD({
			onDragClass: "customizetablecolumns-highlightDrag",
			onDragStop: function(table, row) {
				var $table = $(table);
				self.updateTableIndexes();
				$table.removeClass("customizetablecolumns-dragging");
			},
			onDragStart: function() {
				$table.addClass("customizetablecolumns-dragging");
			}
		});
	}

	fn.prototype.updateTableIndexes = function() {
		var $labelBoxes = cache.$selectedTable.find(".customizecolumns-numbox");

		for (var i = 0; i < $labelBoxes.length; i++) {
			$labelBoxes.eq(i).text(i + 1);
		}
	};

	fn.prototype.updateMsg = function() {
		var tables = cache.$selectedTable.add(cache.$hiddenTable);

		for (var i = 0; i < tables.length; i++) {
			var $table = tables.eq(i);
			var rows = $table.find("tbody tr");

			if (rows.length == 0) {
				$table.hide();
				$table.next("p.customizecolumns-msg").show();
			}
			else if (rows.length == 1) {
				$table.show();
				$table.next("p.customizecolumns-msg").hide();
			}
		}
	};

	fn.prototype.moveRowToTable = function($row, $table) {
		// Pull the row out of the dom
		$row.remove();

		// Add the row to the end of the table body
		$table.find("tbody").append($row);

		// Re-init dragging when rows are updated
		cache.$selectedTable.tableDnDUpdate();
	};

	fn.prototype.saveColumns = function() {
		//create data object for columns
		var $td = cache.$selectedTable.find("td[data-field]");
		var apiData = this.createApiData($td);
		var eventData = this.createEventData($td);

		if (apiData.length > 0 && eventData.length > 0) {
			$.ajax({
				url: "~/API/SaveCustomColumns".resolveUrl(),
				type: "POST",
				data: {
					tableId: this.tableId,
					columns: JSON.stringify(apiData)
				},
				dataType: "json",
				success: function() {
					//fire event to trigger table reload
					mod.observer.trigger("custom columns saved", eventData);
				},
				error: function() {
					alert("There was an error saving the columns.");
				}
			});

			this.el.parent().modal("hide");
		}
		else {
			alert("Please select at least one custom column to save.");
		}
	};

	fn.prototype.createApiData = function($td) {
		var result = [];

		for (var i = 0; i < $td.length; i++) {
			var field = $td.eq(i).data("field");

			result.push(field);
		}

		return result;
	};

	fn.prototype.createEventData = function($td) {
		var result = [];

		for (var i = 0; i < $td.length; i++) {
			var fields = $td.eq(i).data("field").split("|");

			for (var x = 0; x < fields.length; x++) {
				result.push(fields[x]);
			}
		}

		return result;
	};	

	fn.prototype.handleAction = function($el) {
		var $row = $el.closest("tr");
		var action = $el.text().toLowerCase();
		var table;
		var newText;

		if (action == "add") {
			var selectedRows = cache.$selectedTable.find("tbody tr");

			if (selectedRows.length >= this.maxColumns) {
				alert("You have reached the the maximum number of custom columns that can be selected.");
				return true;
			}

			table = cache.$selectedTable;
			newText = "Hide";
		}
		else {
			table = cache.$hiddenTable;
			newText = "Add";

			$row.find("span.customizecolumns-numbox").text("-");
		}

		this.moveRowToTable($row, table);
		$el.text(newText);
		$row.removeClass("customizetablecolumns-highlight");
		this.updateTableIndexes();
		this.updateMsg();
	};

	fn.prototype.events = {
		"a.customizecolumns-action": {
			"click": function(e, $el) {
				this.handleAction($el);
			}
		},
		"table.data:not(.customizetablecolumns-dragging) tr": {
			"mouseenter": function(e, $el) {
				$el.addClass("customizetablecolumns-highlight");
			},
			"mouseleave": function(e, $el) {
				$el.removeClass("customizetablecolumns-highlight");
			}
		},
		".customizecolumns-table-selected table.data tr": {
			"touchend": function (e, $el) {
				$el.siblings().removeClass('customizetablecolumns-highlight');
				$el.addClass("customizetablecolumns-highlight");
			}
		},
		"button[data-action=save]": {
			"click": function(e, $el) {
				this.saveColumns();
			}
		}
	};

});